export default __webpack_public_path__ + "static/media/untied-logo-text.2b7d46e8.png";